<div fxFlex fxLayout="row" fxLayoutAlign="start center" class="row-container">
  <div>
    {{ node.data.vehicle.sideNumber }}
  </div>

  <div fxFlex fxFlexFill fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons">
    <button mat-icon-button (click)="showOnMap()" matTooltip="{{ 'showOnMap' | translate }}">
      <mat-icon svgIcon="gps_fixed"></mat-icon>
    </button>
    <button mat-icon-button (click)="showDevicesStatuses()" matTooltip="{{ 'devicesStatuses' | translate }}">
      <mat-icon svgIcon="table_rows"></mat-icon>
    </button>
  </div>
</div>
